// Contador de tentativas seguidas de recuperar a sessão sem chegar a um
// usuário válido. Impede loop de redirect/reload: passou do limite, o app
// desiste e mostra a tela de erro. É zerado quando há usuário válido.
export const CHAVE_CONTAGEM_RECARGAS = "count_reloads";
export const MAX_RECARGAS = 5;

const storageDisponivel = () => typeof Storage !== "undefined";

export const obterContagemRecargas = () => {
  if (storageDisponivel()) {
    return Number(window.localStorage.getItem(CHAVE_CONTAGEM_RECARGAS)) || 0;
  }
  return 0;
};

export const definirContagemRecargas = contagem => {
  if (storageDisponivel()) {
    const novaContagem =
      contagem !== undefined ? contagem : obterContagemRecargas() + 1;
    window.localStorage.setItem(CHAVE_CONTAGEM_RECARGAS, novaContagem);
  }
};

export const excedeuLimiteRecargas = () =>
  obterContagemRecargas() > MAX_RECARGAS;
